import helper from "actions/helper";

export default function ReportSalary(items, validity, clinicFiltre, profileId) {
    if (!items || items.length < 1)
        return false;

    const style = [{
        name: "wrapText",
        start: [1, 1],
        end: [1, 1]
    }, {
        name: "border",
        start: [3, 1],
        end: [3, 3]
    }, {
        name: "bold",
        start: [1, 1],
        end: [1, 6]
    }, {
        name: "bold",
        start: [2, 1],
        end: [2, 6]
    }];

    const width = [
        { key: 'A', width: 20 },
        { key: 'B', width: 20 },
        { key: 'C', width: 20 },
        { key: 'D', width: 20 },
        { key: 'E', width: 20 },
        { key: 'F', width: 20 },
    ];

    const text = [
        [`Отчет сформирован за период с ${validity}`],
        ["ФИО врача", "Клиника", "Сумма выставленно", "Сумма оплачено", "Материалы", "Рентген"]
    ];
    const itog = {
        invoiceAmount: 0,
        paid: 0,
        materials: 0,
        rentgen: 0,
    };

    items.forEach(it => {
        const { doctor, clinicId, invoiceAmount, paid, materials, rentgen, doctorId, returnsSelectedPeriod } = it;

        let write = clinicFiltre ? false : true;
        if (clinicFiltre && clinicFiltre === clinicId)
            write = true;

        if (helper.isDoctor() && profileId)
            write = (write && doctorId === profileId) ? true : false;

        if (write) {
            itog.invoiceAmount += (invoiceAmount - returnsSelectedPeriod);
            itog.paid += paid;
            itog.materials += materials;
            itog.rentgen += rentgen;

            text.push([doctor, helper.getClinicNameById(clinicId), invoiceAmount - returnsSelectedPeriod, paid, materials, rentgen]);
        }

    });
    const { invoiceAmount, paid, materials, rentgen } = itog;
    text.push(["Итого", "", invoiceAmount, paid, materials, rentgen]);

    style.push({
        name: "bold",
        start: [text.length, 1],
        end: [text.length, 6]
    });

    const merges = [
        { start: [1, 1], end: [1, 4] }
    ];

    const data = { text, style, width, merges };

    helper.xlsx.exportToExcel(data, "ReportSalary.xlsx");

}
